import { OtpContainer } from 'components/auth/otp/container/OtpContainer';
import { CheckContainer } from 'components/auth/check/container/CheckContainer';
import { EmailContainer } from 'components/auth/email/container/EmailContainer';
import { LoginContainer } from 'components/auth/login/container/LoginContainer';
import { TellGateway } from 'components/auth/tellGateway/TellGateway';
import TellGatewayCheck from 'components/auth/tellGateway/TellGatewayCheck';
import { MainContainer } from 'components/auth/main/container/MainContainer';

const authRoutes = [
  { path: '', element: <MainContainer />, pageTitle: 'Login' }, // index route
  { path: 'login', element: <LoginContainer />, pageTitle: 'Login' },
  { path: 'open-banking', element: <TellGatewayCheck />, pageTitle: 'Tell Gateway Check' },
  { path: 'tell-gateway', element: <TellGateway />, pageTitle: 'Tell Gateway' },
  { path: 'email', element: <EmailContainer />, pageTitle: 'Login' },
  { path: 'checking/:id?', element: <CheckContainer />, pageTitle: 'Login' },
  { path: 'otp', element: <OtpContainer />, pageTitle: 'Login' },
];

export default authRoutes;
